import { render, staticRenderFns } from "./CImage.vue?vue&type=template&id=0531671f"
import script from "./CImage.vue?vue&type=script&lang=js"
export * from "./CImage.vue?vue&type=script&lang=js"
import style0 from "./CImage.vue?vue&type=style&index=0&id=0531671f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports